import React from "react";
 import { TestiMonials } from "./Containt_home";

const Resourses = ()=>{
    return <div>
    <h1>Resourses</h1>
      <TestiMonials />;
    </div>
}
export default Resourses;